import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { Direction } from '@microsoft/fast-web-utilities';
import gotoStyles from './GoTo.styles.scss';
import gotoAppStyles from './GoToApp.styles.scss';
import gotoresolveStyles from './GoToResolve.styles.scss';
export class ThemeProviderComponent extends FoundationElement {
    constructor() {
        super(...arguments);
        this.direction = Direction.ltr;
        this.theme = 'light';
        this.skin = 'gotoadmin';
        this.automatic = false;
        this.rebranding2021 = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setRebrandingFlagOnBody(this.rebranding2021);
    }
    rebranding2021Changed(_, newValue) {
        this.setRebrandingFlagOnBody(newValue);
    }
    skinChanged(_previousValue, newValue) {
        var _a, _b;
        if (!this.getGlobalThemeProvider() || this.isGlobalThemeProvider()) {
            (_a = document.querySelector('#chameleon-styling')) === null || _a === void 0 ? void 0 : _a.remove();
            const style = document.createElement('style');
            style.id = 'chameleon-styling';
            style.innerHTML = this.getSkinStyleSheet(newValue);
            (_b = document.querySelector('body')) === null || _b === void 0 ? void 0 : _b.appendChild(style);
        }
    }
    themeChanged(_oldValue, newTheme) {
        this.classList.toggle('theme-dark', newTheme === 'dark');
        document.body.classList.toggle('theme-dark', newTheme === 'dark');
    }
    automaticChanged(_oldValue, isAutomatic) {
        this.classList.toggle('enable-darkmode', isAutomatic);
    }
    isGlobalThemeProvider() {
        const themeProvider = this.getGlobalThemeProvider();
        return themeProvider === this;
    }
    getGlobalThemeProvider() {
        return document.querySelectorAll('chameleon-theme-provider')[0];
    }
    getSkinStyleSheet(skin) {
        switch (skin.toLowerCase()) {
            case 'gotoresolve':
                return gotoresolveStyles;
            case 'gotoapp':
                return gotoAppStyles;
        }
        return gotoStyles;
    }
    setRebrandingFlagOnBody(flagValue) {
        if (this.isGlobalThemeProvider()) {
            document.body.toggleAttribute('rebranding2021', flagValue);
        }
    }
}
__decorate([
    attr
], ThemeProviderComponent.prototype, "theme", void 0);
__decorate([
    attr
], ThemeProviderComponent.prototype, "skin", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ThemeProviderComponent.prototype, "automatic", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ThemeProviderComponent.prototype, "rebranding2021", void 0);
